import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import $ from "jquery";
import { Helmet } from "react-helmet";

export default function ResetPassword() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const [loading, setloading] = useState(false);
  const [errMsg, seterrMsg] = useState(null);
  let navigate = useNavigate();

  async function handleReset(values) {
    setloading(true);
    try {
      let data = await axios.put(
        `${baseURL}/api/v1/auth/resetPassword`,
        values
      );
      // console.log (data)
      if (data.data.token) {
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
      seterrMsg(error.response.data.message);
      setloading(false);
      $(".err").fadeIn(300, () => {
        setTimeout(() => {
          $(".err").fadeOut(300);
        }, 2000);
      });
    }
  }

  let validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is Required")
      .email("Invalid email address *exemple@yyy.zzz"),
    newPassword: Yup.string()
      .required("Password is required")
      .matches(
        /^[A-Z][a-z0-9]{5,10}$/,
        "Password must start with Capital Letter includes at least 5 and less than 10 chars"
      ),
  });
  let formik = useFormik({
    initialValues: {
      email: "",
      newPassword: "",
    },
    validationSchema,
    onSubmit: handleReset,
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Reset Your Password</title>
      </Helmet>
      <div className=" w-75 mx-auto py-4 ">
        <h3 className=" mb-3">Create new password:</h3>
        <p className="alert alert-warning">
          We'll ask for this password whenever you sign in
        </p>

        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="email">Email</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            type="email"
            name="email"
            id="email"
            className=" form-control mb-2"
          />
          {formik.errors.email && formik.touched.email ? (
            <div className=" alert alert-danger">{formik.errors.email}</div>
          ) : null}

          <label htmlFor="newPassword">New newPassword</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.newPassword}
            type="newPassword"
            name="newPassword"
            id="newPassword"
            className=" form-control mb-2"
          />
          {formik.errors.newPassword && formik.touched.newPassword ? (
            <div className=" alert alert-danger">
              {formik.errors.newPassword}
            </div>
          ) : null}
          <div style={{ display: "none" }} className="alert alert-danger err">
            {errMsg}
          </div>
          {loading ? (
            <button className="btn bg-main text-white mt-1" type="button">
              {" "}
              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
            </button>
          ) : (
            <button
              disabled={!(formik.isValid && formik.dirty)}
              className="btn bg-main text-white mt-1"
              type="submit"
            >
              Submit{" "}
            </button>
          )}
        </form>
        <Link className="d-block mt-2 hoveringClick" to="/register">
          Do you have an account? Create account
        </Link>
      </div>
    </>
  );
}
